$(window).on('load', function(){
  sizing();
});

$(window).resize(function(){
  fixHeight();
});

$(document).ready(function () {
  
  var splideOptions = {
    perPage: 1,
  };
  
  var imageHotspotSlider = new Splide("#image-hotspot", splideOptions).mount();
  
});

function fixHeight(type){
  var tabWrapper = $(".image-hotspot .content-wrapper.desktop .content");
  var activeTab = tabWrapper.find(".active");
  var activeTabHeight = activeTab.outerHeight();

  activeTabHeight = activeTab.outerHeight();

  tabWrapper
  .stop()
  .animate({ height: activeTabHeight },0)
}

function sizing(type) {
  // Variables
  var clickedTab = $(".image-hotspot .markers > .active");
  var tabWrapper = $(".image-hotspot .content-wrapper.desktop .content");
  var activeTab = tabWrapper.find(".active");
  var activeTabHeight = activeTab.outerHeight();

  // Show tab on page load
  activeTab.show();

  // Set height of wrapper on page load
  tabWrapper.height(activeTabHeight);

  $(".image-hotspot .markers > li").on("click", function () {
    // Remove class from active tab
    $(".image-hotspot .markers > li").removeClass("active");

    // Add class active to clicked tab
    $(this).addClass("active");

    // Update clickedTab variable
    clickedTab = $(".image-hotspot .markers .active");

    // fade out active tab
    activeTab.fadeOut(250, function () {
      // Remove active class all markers
      $(".image-hotspot .content > li").removeClass("active");

      // Get index of clicked tab
      var clickedTabIndex = clickedTab.index();

      // Add class active to corresponding tab
      $(".image-hotspot .content > li").eq(clickedTabIndex).addClass("active");

      // update new active tab
      activeTab = $(".image-hotspot .content > .active");

      // Update variable
      activeTabHeight = activeTab.outerHeight();

      // Animate height of wrapper to new tab height
      tabWrapper
      .stop()
      .delay(50)
      .animate(
        {
          height: activeTabHeight
        },
        250,
        function () {
          // Fade in active tab
          activeTab.delay(50).fadeIn(250);
        }
      );
    });
  });
}